import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { 
  FiCalendar, 
  FiMapPin, 
  FiClock, 
  FiShoppingBag, 
  FiTruck, 
  FiMusic, 
  FiSmile, 
  FiExternalLink,
  FiGift,
  FiStar
} from "react-icons/fi";
import EventVendors from "./EventVendors";
import "./eventpage.css";

const TABS = [
  { id: "overview", label: "OVERVIEW" },
  { id: "vendors", label: "CURATED VENDORS" },
{ id: "performances", label: "LIVE PERFORMANCES" },

];

const PERFORMANCES_LINEUP = [
  {
    time: "Fri Dec 11 • 2:00 PM – 4:00 PM",
    title: "Acoustic Sunset Sessions",
    artist: "Live Nairobi Local Acts",
    description: "Laid-back acoustic sets to kick off your holiday weekend shopping.",
  },
  {
    time: "Sat Dec 12 • 1:00 PM & 4:00 PM",
    title: "Festive Brass & Choir Showcase",
    artist: "The Nairobi Holiday Ensemble",
    description: "Classic Christmas carols with a vibrant Afro-jazz fusion twist.",
  },
  {
    time: "Sat Dec 12 • 5:00 PM – 7:00 PM",
    title: "Twilight DJ Sets & Sundowner",
    artist: "Guest Resident DJs",
    description: "Upbeat Afro-house, soul, and festive grooves at the main bar stage.",
  },
  {
    time: "Sun Dec 13 • 12:00 PM – 3:00 PM",
    title: "Family Christmas Pageant & Kids Corner",
    artist: "Interactive Youth Performers",
    description: "Live story sessions, kids workshops, and Father Christmas photo-ops.",
  },
];

const ChristmasFestival2026 = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>Bizarre Bazaar Christmas Festival 2026 | Dec 11–13, Gigiri | Biz Baz Events</title>
        <meta
          name="description"
          content="Join Nairobi's biggest holiday market! The Bizarre Bazaar Christmas Festival happens Dec 11–13, 2026 at KSTVET, Gigiri. 200+ artisan vendors, gourmet food, live music, Father Christmas & kids zone."
        />
        <meta 
          name="keywords" 
          content="Bizarre Bazaar Christmas, BizBaz Christmas 2026, Gigiri Christmas Market, Nairobi Christmas Festival, KSTVET events, Kenya craft markets, Nairobi holiday shopping"
        />
        <link rel="canonical" href="https://bizbazevents.com/events/christmas-festival" />

        {/* OpenGraph / Facebook SEO */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://bizbazevents.com/events/christmas-festival" />
        <meta property="og:title" content="Bizarre Bazaar Christmas Festival 2026 | Dec 11–13, Gigiri" />
        <meta 
          property="og:description" 
          content="Shop 200+ local makers, enjoy gourmet street food, live holiday music, and family fun at KSTVET, Gigiri." 
        />
        <meta property="og:image" content="https://bizbazevents.com/images/posters/2026/Christmas-Edition-Dec-2026.png"/>

        {/* Twitter Card SEO */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bizarre Bazaar Christmas Festival 2026 | Gigiri" />
        <meta name="twitter:description" content="Dec 11–13, 2026 at KSTVET, Gigiri. 200+ artisan vendors, live music & holiday experiences." />
        <meta name="twitter:image" content="https://bizbazevents.com/images/posters/2026/Christmas-Edition-Dec-2026.png" />

        {/* Google Schema.org Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Event",
            "name": "Bizarre Bazaar Christmas Festival 2026",
            "startDate": "2026-12-11T09:00:00+03:00",
            "endDate": "2026-12-13T19:00:00+03:00",
            "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
            "eventStatus": "https://schema.org/EventScheduled",
            "location": {
              "@type": "Place",
              "name": "Kenya School of TVET (KSTVET)",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "UN Avenue",
                "addressLocality": "Gigiri, Nairobi",
                "addressCountry": "KE"
              }
            },
            "image": ["https://bizbazevents.com/images/posters/2024/Christmas-Edition-Dec-2026.png"],
            "description": "Nairobi's premier Christmas market featuring 200+ curated artisans, food court, live music, kids activity zone, and holiday experiences.",
            "offers": {
              "@type": "Offer",
              "url": "https://bizbazevents.com/images/posters/2024/Christmas-Edition-Dec-2026.png",
              "price": "500",
              "priceCurrency": "KES",
              "availability": "https://schema.org/InStock",
              "validFrom": "2026-11-01"
            },
            "organizer": {
              "@type": "Organization",
              "name": "Biz Baz Events",
              "url": "https://bizbazevents.com"
            }
          })}
        </script>
      </Helmet>

      <div className="eventpage-container">
        
        {/* HERO BANNER */}
        <div 
          className="event-hero" 
          style={{ backgroundImage: "url('/images/REM00008.jpg')" }}
        >
          <div className="event-hero-overlay">
            <div className="hero-content-inner">
              <span className="hero-category-tag">BIZARRE BAZAAR FESTIVAL</span>
              <h1 className="hero-event-title">THE CHRISTMAS EDITION 2026</h1>
              
              <div className="hero-meta-strip">
                <div className="meta-item">
                  <FiCalendar className="meta-icon" />
                  <span>Dec 11th, 12th &amp; 13th, 2026</span>
                </div>
                <div className="meta-item">
                  <FiMapPin className="meta-icon" />
                  <span>KSTVET, UN Avenue, Gigiri</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* NAVIGATION TABS */}
        <div className="event-tabbar-wrap">
          <nav className="event-tabbar" role="tablist">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`event-tab ${activeTab === tab.id ? "event-tab--active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* TWO COLUMN LAYOUT */}
        <div className="event-body-layout">
          
          {/* MAIN TAB CONTENT */}
          <main className="event-body-main">
            {activeTab === "overview" && (
              <div id="event-panel-overview" role="tabpanel">
                
                <div className="ep-intro-box">
                  <p className="ep-intro">
                    <strong>Bizarre Bazaar Christmas Festival</strong> is Nairobi’s ultimate open-air holiday destination — bringing together three days of artisan shopping, festive treats, live entertainment, and unforgettable family memories.
                  </p>
                  <p>
                    Step into an open-air Christmas market built by 200+ local makers, craftspeople, fashion designers, beauty creators, and food entrepreneurs from across Kenya and Africa.
                  </p>
                  <p>
                    Uncover unique handcrafted holiday gifts, bespoke home décor, festive fashion, organic skincare, stocking stuffers, and one-of-a-kind finds you won't get on standard store shelves.
                  </p>
                </div>

                {/* HIGHLIGHTS */}
                <div className="ep-highlights-grid">
                  <div className="highlight-card">
                    <FiGift className="hl-icon" />
                    <h4>200+ Holiday Vendors</h4>
                    <p>Curated artisan gifts, fashion, jewelry, home décor &amp; crafts.</p>
                  </div>
                  <div className="highlight-card">
                    <FiTruck className="hl-icon" />
                    <h4>Festive Food Court</h4>
                    <p>Mulled wine, gourmet food trucks, artisan bakes &amp; craft cocktails.</p>
                  </div>
                  <div className="highlight-card">
                    <FiMusic className="hl-icon" />
                    <h4>Live Stage &amp; Carols</h4>
                    <p>Brass ensembles, acoustic sets, festive carols &amp; evening DJ sets.</p>
                  </div>
                  <div className="highlight-card">
                    <FiSmile className="hl-icon" />
                    <h4>Kids Zone &amp; Santa</h4>
                    <p>Father Christmas visits, craft workshops &amp; dog-friendly grounds.</p>
                  </div>
                </div>

                {/* ACCESS BADGES */}
                <div className="event-access-grid">
                  <div className="event-access-badge eab--blue">
                    <span className="eab-icon">♿</span>
                    <span className="eab-label">Venue Accessible</span>
                  </div>
                  <div className="event-access-badge eab--amber">
                    <span className="eab-icon">👪</span>
                    <span className="eab-label">Family Friendly</span>
                  </div>
                  <div className="event-access-badge eab--green">
                    <span className="eab-icon">🦮</span>
                    <span className="eab-label">Dog Friendly (On Leash)</span>
                  </div>
                </div>

              </div>
            )}

            {/* PERFORMANCES TAB */}
            {activeTab === "performances" && (
              <div id="event-panel-performances" role="tabpanel" className="ep-performances-panel">
                <div className="ep-intro-box">
                  <h2>LIVE PERFORMANCES &amp; SCHEDULE</h2>
                  <p>Experience live music, holiday carols, and evening DJ sets across all three days at KSTVET Grounds.</p>
                </div>

                <div className="performance-schedule-list">
                  {PERFORMANCES_LINEUP.map((item, idx) => (
                    <div className="performance-card" key={idx}>
                      <div className="perf-time-badge">
                        <FiClock className="p-icon" />
                        <span>{item.time}</span>
                      </div>
                      <h3 className="perf-title">{item.title}</h3>
                      <div className="perf-artist">
                        <FiStar className="p-icon-star" />
                        <span>{item.artist}</span>
                      </div>
                      <p className="perf-desc">{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === "vendors" && (
              <div id="event-panel-vendors" role="tabpanel">
                <EventVendors eventId="c6d6af46-e3ac-43fe-b5ec-319c9988fb61" />
              </div>
            )}
          </main>

          {/* STICKY SIDEBAR */}
          <aside className="event-sidebar">
            
            {/* OFFICIAL POSTER */}
            <div className="sidebar-poster-card">
              <img 
                src="https://bizbazevents.com/images/posters/2024/Christmas-Edition-Dec-2026.png" 
                alt="Bizarre Bazaar Christmas Festival 2026 Official Poster" 
                className="event-poster-img"
              />
            </div>

            {/* TICKETS & DETAILS */}
            <div className="sidebar-ticket-card">
              <h3 className="sidebar-title">EVENT TICKETS &amp; DETAILS</h3>
              
              <div className="sidebar-pricing">
                <div className="price-row">
                  <span>Adults (Daily Charge)</span>
                  <strong>Ksh 500</strong>
                </div>
                <div className="price-row">
                  <span>Under 18s (Daily Charge)</span>
                  <strong>Ksh 200</strong>
                </div>
              </div>

              <div className="sidebar-meta">
                <div className="s-meta-item">
                  <FiCalendar className="s-icon" />
                  <span>Fri Dec 11th – Sun Dec 13th, 2026</span>
                </div>
                <div className="s-meta-item">
                  <FiClock className="s-icon" />
                  <span>9:00 AM – 7:00 PM Daily</span>
                </div>
                <div className="s-meta-item">
                  <FiMapPin className="s-icon" />
                  <span>KSTVET, UN Avenue, Gigiri</span>
                </div>
              </div>

              <a 
                href="https://kenyabuzz.com/events/event/bizarre-bazaar-christmas-festival-2026" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="sidebar-cta-btn"
              >
                GET TICKETS ON KENYABUZZ <FiExternalLink />
              </a>

              <p className="sidebar-note">Tickets available in advance online or at the door via M-Pesa &amp; Cash.</p>
            </div>

          </aside>

        </div>
      </div>
    </>
  );
};

export default ChristmasFestival2026;